import { setTag } from '@sentry/react';
import { clarity } from 'clarity-js';
import { jwtDecode } from 'jwt-decode';
import { isEmptyString, oz } from '@weft/utils';
import { getLocalStorageString } from '../utils/local-storage';

export function useIntegrations() {
  const token = getLocalStorageString('token');

  if (isEmptyString(token)) {
    return;
  }

  const DecodedJwtSchema = oz.custom<{ email: string, ['custom:accountId']: string, ['auth_time']: number }>();

  const decoded = jwtDecode(token);
  const parsedDecodedJwt = DecodedJwtSchema.safeParse(decoded);

  if (!parsedDecodedJwt.success) {
    return;
  }

  const { email, ['custom:accountId']: accountId, ['auth_time']: authTime } = parsedDecodedJwt.data;

  clarity.set('email', email);
  clarity.set('accountId', accountId);

  setTag('user.email', email);
  setTag('user.accountId', accountId);
  setTag('user.authTime', authTime * 1000);
}